import { defineModule } from '../utils/helpers';

const getElements = () => ({
  back: document.querySelector<HTMLButtonElement>('[data-history-back]'),
  home: document.querySelector<HTMLAnchorElement>('[data-error-home]'),
});

const goBack = () => {
  window.history.back();
};

/**
 * "Vorige pagina" is the primary action on the 404, but a visitor who arrived
 * straight from a search result or a pasted link has nothing to go back to.
 * Drop the button in that case and promote the homepage link to primary, so the
 * page never offers a dead end dressed up as its main call to action.
 */
const setup = () => {
  const { back, home } = getElements();
  if (!back) return;

  if (window.history.length > 1) {
    back.addEventListener('click', goBack);

    return;
  }

  back.remove();
  home?.classList.replace('btn--ghost', 'btn--primary');
};

const cleanup = () => {
  const { back } = getElements();

  back?.removeEventListener('click', goBack);
};

export default defineModule(setup, cleanup);
